export default class search {
    constructor(opt) {
        this.opt = opt;

        if (!opt.minInputLength) {
            this.opt.minInputLength = 3;
        }

        this.bindHandlers();
    }

    bindHandlers() {

        let _self = this;

        let delay = (function () {
            let timer = 0;
            return function (callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })();


        _self.opt.searchInput.keyup(function () {
            delay(function () {
                _self.search();
            }, 250);
        });

    }

    search() {
        let _self = this;
        let words = _self.opt.searchInput.val();

        if (words.length < _self.opt.minInputLength) {
            return false;
        }

        let url = _self.opt.searchUrl + '/' + words;

        $.get(url, function () {

        }).done(function (data) {

            _self.resultsClear();
            _self.showResult(data.html);


        }).fail(function (data) {
            console.info(data);
        });
    }

    resultsClear() {
        this.opt.resultWrapper.empty();
    }

    showResult(html) {
        this.opt.resultWrapper.append(html);
    }
}
